<template>
  <el-container id="main-container" style="min-height: 100%; border: 1px solid #eee;">
    <div style="position: fixed; width: 225px; height: 100%; background: #fff">
      <div class="side-logo">
        <i class="el-icon-message-solid" /><span class="title">消息中心</span>
      </div>
      <aside>
        <el-menu 
        :default-active="$route.name"
        >
          <el-menu-item index="chart" @click="toPath('/chart')">
            <i class="el-icon-monitor"></i>
            <span>统计信息</span>
          </el-menu-item>
          <el-menu-item index="msgTemplate" @click="toPath('/msgTemplate')">
            <i class="el-icon-menu"></i>
            <span slot="title">模板管理</span>
          </el-menu-item>
          <el-menu-item index="qw" @click="toPath('/qw')">
            <i class="el-icon-chat-line-round"></i>
            <span slot="title">企微消息</span>
          </el-menu-item>
           <!-- <el-menu-item index="4" @click="toPath('/sms')">
            <i class="el-icon-chat-dot-square"></i>
            <span slot="title">短信信息</span>
          </el-menu-item> -->
          <el-menu-item index="mail" @click="toPath('/mail')">
            <i class="el-icon-message"></i>
            <span slot="title">邮件信息</span>
          </el-menu-item>
          <el-menu-item index="business" @click="toPath('/business')">
            <i class="el-icon-postcard"></i>
            <span slot="title">业务信息</span>
          </el-menu-item>
          <el-menu-item index="sendMail" @click="toPath('/sendMail')">
            <i class="el-icon-setting"></i>
            <span slot="title">企微消息配置</span>
          </el-menu-item>
          <el-menu-item index="group" @click="toPath('/group')">
            <i class="el-icon-setting"></i>
            <span slot="title">接收组管理</span>
          </el-menu-item>
          <el-menu-item index="themeConfig" @click="toPath('/themeConfig')">
            <i class="el-icon-s-check"></i>
            <span slot="title">主题配置</span>
          </el-menu-item>
        </el-menu>
      </aside>
    </div>
    <el-main position="relative" style="margin-left: 225px">
      <div class="header">
        <div class="header-left">
          <AppSelect />
        </div>
        <div class="header-right">
          <el-dropdown @command="handleCommand">
            <span class="user-dropdown">
              <el-avatar
                :size="32"
                icon="el-icon-user-solid"
                class="avatar"
              ></el-avatar>
              <span class="user-name">{{ userName }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                icon="el-icon-switch-button"
                divided
                command="loginOut"
                >退出登录</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="main-content">
        <router-view />
      </div>
    </el-main>
  </el-container>
</template>

<script>
import AppSelect from "../components/Appselect.vue";
export default {
  name: "index",
  components: { AppSelect },
  computed: {
    userName() {
      const userInfo = this.$store.state.request.userInfo || {};
      return userInfo.name || userInfo.account || "未登录用户";
    },
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    handleCommand(command) {
      if (command === "loginOut") {
        console.log("退出登录");
        this.$store.dispatch("loginOut").then(() => {
          this.$router.push("/login");
        });
      }
    },
    toPath(path) {
      console.log('跳转 -> ' + path)
      this.$router.push(path)
    },
  }
}
</script>

<style scoped>
.el-container aside {
  width: 200px;
  background: #fff;
  padding: 13px 0 0 10px;
}

.el-container aside::-webkit-scrollbar {
  display: none;
}

aside .el-menu-item, aside .el-submenu__title {
  /*color: rgba(0, 0, 0, 1);*/
  text-align: left;
  font-size: 16px;
}

aside .el-submenu .el-menu-item.is-active, aside .el-menu-item.is-active,
aside .el-submenu .el-menu-item.is-active:hover, aside .el-menu-item.is-active:hover {
  background: linear-gradient(118deg, #409efe, rgba(64, 158, 254, 0.7));
  box-shadow: 0 0 0.625rem 0.0625rem rgb(64 158 254 / 70%);
  color: #fff;
  font-weight: 400;
  border-radius: 0.25rem;
}

.el-container aside .el-menu {
  height: calc(100% - 80px);
  border-radius: 0;
  background-color: #fff;
  border-right: 0;
  min-width: 200px;
}

.el-container aside .el-submenu .el-menu-item {
  min-width: 60px;
  max-width: 200px;
  padding-left: 30px !important;
}

.el-container aside .el-menu {
  width: 60px;
}

.el-container aside .el-menu .el-menu-item, .el-container aside .el-submenu .el-submenu__title {
  height: 46px;
  line-height: 46px;
  padding-left: 10px !important;
}

.el-menu-item-group .el-menu-item-group__title {
  padding: 0;
}
</style>
<style scoped lang="scss">
.side-logo {
  box-shadow: 1px 1px 0 0 rgba(0, 0, 0, 0.1);
  background: white;
  padding: 0 30px;
  position: relative;
  height: 64px;
  overflow: hidden;
  transition: all 0.3s;
  line-height: 64px;
  width: 100%;
  font-size: 18px;
  box-sizing: border-box;
  .title {
    color: rgb(51, 51, 51);
    margin-left: 10px;
  }
}
/* 头部导航栏样式 */
.header {
  height: 65px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}

.header-right {
  display: flex;
  align-items: center;
}

.user-dropdown {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.user-dropdown:hover {
  background-color: #f5f5f5;
}

.avatar {
  background-color: #409eff;
}

.user-name {
  margin-left: 8px;
  font-size: 14px;
  color: #333;
}

.el-icon-arrow-down {
  margin-left: 5px;
  font-size: 12px;
  color: #999;
}
.el-main{
  padding:0;
}
.main-content {
  padding: 16px;
  background-color: #fff;
  margin: 10px 0 0 10px;
  height: calc(100% - 75px);
  box-sizing: border-box;
}
</style>
